module.exports = __webpack_public_path__ + "static/media/presentation.90ecb501.pptx";